var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`text-center text-[13px] md:text-[22px] text-white font-medium px-[10px] py-[18px] md:py-[22px] ${_vm.data.type}`,domProps:{"innerHTML":_vm._s(_vm.data.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }